export default __webpack_public_path__ + "1b790a3a17a54ffc065adec44cf7db1f.svg";